import { STATUS } from '../../interfaces';

export const getDialogReportStatus = (status: STATUS) => (status === STATUS.CREATED ? 'active' : status.toLowerCase());
